export const ArrowUpRightIcon: React.FC<React.SVGProps<SVGSVGElement>> = (props) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" {...props}>
      <defs />
      <circle cx={12} cy={12} r={10.5} fill="#c4f0eb" />
      <path
        d="M1.25,18.25,8.586,10a1.042,1.042,0,0,1,1.432-.107l4.464,3.72a1.038,1.038,0,0,0,1.43-.11L22.75,5.75"
        fill="none"
        stroke="#0f172a"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <polyline
        points="15.812 5.75 22.75 5.75 22.75 11.729"
        fill="none"
        stroke="#0f172a"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
